import { useEffect, useRef } from 'react';

import observer from 'saddlebag-observer';

type LoginCallback = () => void;

const useUpdatedActionAfterLogingIn = ({
  callback,
}: {
  callback: LoginCallback;
}) => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    const loginSuccessHandler = observer.subscribe('sid-login-success', () => {
      callbackRef.current();
    });
    return () => {
      observer.unsubscribe(loginSuccessHandler);
    };
  }, []);
};

export default useUpdatedActionAfterLogingIn;
